import React, { useRef } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import emailjs from '@emailjs/browser'
import { MdArrowOutward } from 'react-icons/md'
import { RevealLine } from './ui/Reveal'

export const EmailSection = () => {
  const notify = () =>
    toast.success('Message sent!', {
      position: 'bottom-left',
      autoClose: 5000,
      theme: 'dark',
    })

  const form = useRef()

  const [formData, setformData] = React.useState({ userName: '', message: '', subject: '' })
  const [isSending, setIsSending] = React.useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setformData({ ...formData, [name]: value })
  }

  const handleSubmit = async(event) => {
    event.preventDefault()
    if (isSending) return
    setIsSending(true)
    try {
     await emailjs.sendForm(
       process.env.REACT_APP_SERVICE_ID,
       process.env.REACT_APP_TEMPLATE_ID_ONE,
       form.current,
       'l652k1BHgkmObYqoT',
     )
        // .then(
        //   result => console.log(result.text),
        //   error => console.log(error.text),
        // )
      notify()
      setformData({ ...formData, message: '', userName: '', subject: '' })
    } catch (error) {
      toast.error(`Failed to send message.${error?.message || ' Unknown error'}`, {
        position: 'bottom-left',
        autoClose: 5000,
        theme: 'dark',
      })

      console.error('Failed to send message:', error)
    } finally {
      setIsSending(false)
    }
  }

  const field = ' w-full bg-transparent border-0 border-b border-ink/20 rounded-none px-0 py-3 text-ink placeholder:text-ink/30 outline-none transition-colors focus:border-mint-deep'
  const label = ' font-mono text-xs uppercase tracking-[0.2em] text-ink/40'

  return (
    <section id='contact' className=' px-6 md:px-10 py-24 md:py-32 border-b border-ink/10'>
      <div className=' max-w-7xl mx-auto'>
        <p className=' font-mono text-sm text-mint-deep'>(04)</p>
        <h2 className=' font-display font-semibold text-maroon text-[clamp(2.5rem,10vw,7.5rem)] leading-[0.9] tracking-[-0.02em] mt-4'>
          <RevealLine>Let&apos;s work</RevealLine>
          <RevealLine delay={0.1}>
            <span className=' italic font-normal text-mint-deep'>together</span>
          </RevealLine>
        </h2>

        <div className=' grid md:grid-cols-12 gap-12 md:gap-16 mt-16 md:mt-24'>
          <div className=' md:col-span-5'>
            <a
              href='mailto:info@wilsontomisin.com'
              className=' group inline-flex items-center gap-2 font-display text-2xl md:text-3xl text-ink tracking-tight hover:text-mint-deep transition-colors break-all'>
              info@wilsontomisin.com
              <MdArrowOutward className=' shrink-0 transition-transform duration-300 group-hover:rotate-45' />
            </a>
            <p className=' mt-6 text-base md:text-lg leading-relaxed text-ink/60 max-w-sm'>
              I&apos;m currently looking for new opportunities. My inbox is always open —
              whether you have a question or just want to say hi, I&apos;ll get back to you.
            </p>
            <div className=' mt-8 flex flex-wrap gap-x-6 gap-y-2 font-mono text-xs uppercase tracking-[0.15em] text-ink/50'>
              <a href='https://github.com/WilsonTomisin' target='_blank' rel='noopener noreferrer' className=' hover:text-mint-deep transition-colors'>GitHub</a>
              <a href='https://www.linkedin.com/in/oluwatomisin-wilson-992923270' target='_blank' rel='noopener noreferrer' className=' hover:text-mint-deep transition-colors'>LinkedIn</a>
              <a href='https://medium.com/@tommywilson972' target='_blank' rel='noopener noreferrer' className=' hover:text-mint-deep transition-colors'>Medium</a>
              <a href='https://linktr.ee/WilsonTomisin' target='_blank' rel='noopener noreferrer' className=' hover:text-mint-deep transition-colors'>Linktree</a>
            </div>
          </div>

          <form ref={form} onSubmit={handleSubmit} className=' md:col-span-7 flex flex-col gap-8'>
            <div className=' grid sm:grid-cols-2 gap-8'>
              <div className=' flex flex-col gap-2'>
                <label htmlFor='userName' className={label}>Name</label>
                <input id='userName' type='text' name='userName' value={formData.userName} required onChange={handleChange} placeholder='Your name' className={field} />
              </div>
              <div className=' flex flex-col gap-2'>
                <label htmlFor='subject' className={label}>Subject</label>
                <input id='subject' type='text' name='subject' value={formData.subject} required onChange={handleChange} placeholder='To say hello?' className={field} />
              </div>
            </div>
            <div className=' flex flex-col gap-2'>
              <label htmlFor='message' className={label}>Message</label>
              <textarea id='message' name='message' value={formData.message} onChange={handleChange} required rows='5' placeholder='Tell me about it — and how I can reach you...' className={field + ' resize-none'} />
            </div>
            <button
              type='submit'
              disabled={isSending}
              aria-busy={isSending}
              className=' group self-start inline-flex items-center gap-2 bg-maroon text-cream text-sm font-medium px-8 py-4 rounded-full transition-colors duration-300 hover:bg-mint hover:text-panel disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-maroon disabled:hover:text-cream'>
              {isSending ? 'Sending' : 'Send message'}
              {isSending ? (
                <svg className=' h-4 w-4 animate-spin' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
                  <circle cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='3' opacity='0.25' />
                  <path d='M12 2a10 10 0 0 1 10 10' stroke='currentColor' strokeWidth='3' strokeLinecap='round' />
                </svg>
              ) : (
                <MdArrowOutward className=' text-lg transition-transform duration-300 group-hover:rotate-45' />
              )}
            </button>
          </form>
        </div>
        <ToastContainer />
      </div>
    </section>
  )
}
